import React from 'react';
import { Grid } from 'semantic-ui-react';
import classes from './mobileFooter.css';

const today = new Date()
const MobileFooterTextBlurb = () => (
  <Grid.Column width={16} className={classes.column}>
    <p className={classes.footerBlurbText}>
      The Huddle is a member of the Pro Football Writers of America, Fantasy
      Sports Trade Association and Fantasy Sports Writers Association.
    </p>
    <p className={classes.footerBlurbText}>
      Use of this website constitutes acceptance of its <a href="https://static.usatoday.com/privacy/" target="_blank">Privacy Notice</a> and <a href="https://static.usatoday.com/terms/" target="_blank">Terms
      of Use</a>.{' '}
    </p>
    <p className={classes.footerBlurbText}>© { today.getFullYear() } THEHUDDLE.COM</p>
    <p className={classes.footerBlurbText}>
      Part of USA TODAY Sports Digital Properties
    </p>
  </Grid.Column>
);

export default MobileFooterTextBlurb;



// WEBPACK FOOTER //
// ./src/app/components/Footer/MobileFooter/TextBlurb.js